import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { isConfigFlagEnabled } from '../config';
import { YELLOW_COLOR } from '../styles/colors';
import { getNamedVersion } from '../utils/namedVersionUtils';
import { getGitCommit } from '../utils/versionUtils';
export const NamedVersionDevHeaderContainer = () => {
    if (!isConfigFlagEnabled('namedVersionDevHeader')) {
        return null;
    }
    const namedVersion = getNamedVersion();
    if (!namedVersion) {
        return null;
    }
    const gitCommitPrefix = getGitCommit().slice(0, 3);
    return (_jsxs("div", { css: css `
        position: fixed;
        top: 0;
        background-color: rgba(255, 0, 0, 0.3);
        padding: 2px 20px;
        border-radius: 0 0 10px 10px;
        color: white;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100;
        font-weight: bold;
        font-family: sans-serif;
        pointer-events: none;
        user-select: none;
      `, children: [namedVersion, ' ', _jsx("span", { css: css `
          color: ${YELLOW_COLOR};
        `, children: gitCommitPrefix })] }));
};
